<template>
  <div id="app1">
      <Carousel :slides="slides"></Carousel>
  </div>
</template>

<script>
import Carousel from './components/Carousel';

export default {
  name: 'AppS',
   data: () => ({
    slides: [
     "/wp-content/uploads/2024/07/AROANIOS-PHOTO_19-scaled.jpg",
     "/wp-content/uploads/2024/07/AROANIOS-PHOTO_20-scaled.jpg",
    ]
  }),
  components: {
    Carousel,
  }
}
</script>
